import type { StateCreator } from 'zustand';
import type { Profile } from '../types';
import { profilesApi } from '../services/profilesApi';

export interface ProfilesSlice {
  profiles: Profile[];
  profilesLoading: boolean;
  wizardStep: number;
  draftProfile: Partial<Profile>;
  aiSparringResponse: string;
  aiSparringLoading: boolean;
  fetchProfiles: () => Promise<void>;
  createProfile: (data: { name: string; niche?: string; language?: string }) => Promise<void>;
  updateDraft: (data: Partial<Profile>) => void;
  setWizardStep: (step: number) => void;
  triggerAISparring: (prompt: string, niche?: string) => Promise<void>;
}

export const createProfilesSlice: StateCreator<ProfilesSlice> = (set, get) => ({
  profiles: [],
  profilesLoading: false,
  wizardStep: 0,
  draftProfile: {},
  aiSparringResponse: '',
  aiSparringLoading: false,

  fetchProfiles: async () => {
    set({ profilesLoading: true });
    try {
      const profiles = await profilesApi.list();
      set({ profiles, profilesLoading: false });
    } catch {
      set({ profilesLoading: false });
    }
  },

  createProfile: async (data) => {
    await profilesApi.create(data);
    get().fetchProfiles();
    set({ draftProfile: {}, wizardStep: 0 });
  },

  updateDraft: (data) => {
    set((s) => ({ draftProfile: { ...s.draftProfile, ...data } }));
  },

  setWizardStep: (step) => set({ wizardStep: step }),

  triggerAISparring: async (prompt, niche) => {
    set({ aiSparringLoading: true });
    try {
      const res = await profilesApi.aiSparring(prompt, niche);
      set({ aiSparringResponse: res.response, aiSparringLoading: false });
    } catch {
      set({ aiSparringLoading: false });
    }
  },
});
